/* eslint-disable import/no-extraneous-dependencies */
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import 'leaflet/dist/leaflet.css';

import './config/reactotron';

import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import GlobalStyle from '~/styles/global';
import { Internationalization, Theme, Loader, SkipLink } from '~/components';
import VLibrasWidget from '~/components/VLibras/VLibrasWidget.component';
import useDynamicTitle from '~/hooks/useDynamicTitle';

import Routes from './routes';

import store, { persistor } from './store';
import MenuProvider from '~/contexts/menu.context';
import { UrlProvider } from '~/contexts/url.context';

function AppContent() {
  // Hook para título dinâmico - atualiza automaticamente quando os dados forem carregados
  useDynamicTitle('', '{razaoSocial} | PAI - Portal de Acesso à Informação');

  return (
    <>
      <SkipLink />
      <Routes />
      <GlobalStyle />
      {/* Último: VLibras opcional (só após load + 12s) — não bloqueia o Portal */}
      <VLibrasWidget />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Internationalization>
          <Theme>
            <UrlProvider>
              <MenuProvider>
                <Loader>
                  <AppContent />
                </Loader>
              </MenuProvider>
            </UrlProvider>
          </Theme>
        </Internationalization>
      </PersistGate>
    </Provider>
  );
}

export default App;
